import React, { memo } from "react"
import styled, { css } from "styled-components"

import { NAVIGATION_LINKS } from "components/navigation/header/meta"
import { BrowserView, MobileView } from "components/helpers/hide"
import { InlineList, InlineListItem } from "components/box"
import { Link } from "components/text"
import Icon from "components/icon"

import { useOpen } from "hooks/useOpen"

import LeftMobileDropdownMenu from "./menus/left-menu-mobile"
import NavigationDropdown from "./navigation-dropdown"

const LINK_CSS = css`
  color: ${props => props.theme.colors.evergreen};
  font-family: ${props => props.theme.fonts.paragraph};
  font-size: 14px;
  text-decoration: none;
`

const NavbarLink = styled(Link)`
  ${LINK_CSS}
`

const LeftNavigationPanel = () => {
  const { isOpen, handleClose, handleToggle } = useOpen()

  return (
    <NavigationDropdown
      isOpen={isOpen}
      handleClose={handleClose}
      openedDropdownContent={<LeftMobileDropdownMenu handleClose={handleClose} />}
    >
      <BrowserView>
        <InlineList>
          {NAVIGATION_LINKS.map(({ id, title, to }) => (
            <InlineListItem key={id}>
              <NavbarLink to={to}>{title}</NavbarLink>
            </InlineListItem>
          ))}
        </InlineList>
      </BrowserView>

      <MobileView onClick={handleToggle}>
        <Icon name="hamburgerMenu" />
      </MobileView>
    </NavigationDropdown>
  )
}

export default memo(LeftNavigationPanel)
